import React from 'react'
import { socials } from '../../data'

const HeaderSocial = () => {
  return (
    <div className='header__socials'>
      {socials.map(social => (
        <a key={social.id} href={social.link} target='_blank' rel='noreferrer'>
          <img className='social__icon' src={social.icon} alt={social.name} />
        </a>
      ))}
    </div>
  )
}

export default HeaderSocial
